/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import withData from "../withData";
import Gettext from "../common/Gettext";
import Money from "../Money";
import { Flex } from "./shared-styles";

import type { Profile, Account } from "../../redux/CommonTypes";
import { fontSize, rtl } from "../common/styled-mixins";

const Stats = styled(Flex)`
  direction: ${({ theme }) => theme.direction};
  justify-content: flex-start;
  min-height: 94px;
  padding: 0 30px;

  @media (min-width: 960px) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    height: 94px;
  }

  @media (max-width: 959px) {
    justify-content: space-around;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    padding: 0;
  }

  @media (max-width: 479px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const Block = styled.div`
  direction: ${props => props.theme.direction};
  font-size: ${fontSize(16)};
  line-height: 1.125em;
  color: #717171;

  :not(:last-of-type) {
    ${rtl("margin-right", "2.438em")};
  }

  :last-of-type {
    ${rtl("margin-right", "auto")};
  }

  @media (max-width: 959px) {
    font-size: ${fontSize(16)};
    text-align: center;

    :not(:last-of-type),
    :last-of-type {
      ${rtl("margin-right", "0")};
    }
  }

  @media (max-width: 640px) {
    font-size: ${fontSize(14)};
  }

  @media (max-width: 479px) {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    text-align: left;

    :not(:first-of-type) {
      padding-top: 11px;
    }
  }

  @media (max-width: 414px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: ${fontSize(14)};
  }
`;

const Header = styled.span`
  @media (max-width: 479px) {
    flex: 0 1 30%;
  }
`;

const Item = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  color: ${({ theme }) => theme.money || "#000"};

  ${props =>
    props.primary &&
    css`
      font-weight: 400;
      color: #4e2a81;
    `};
  @media (max-width: 959px) {
    display: block;
    width: 100%;
    font-weight: 700;
    font-size: 16px;
    padding: 0.643em 0;
  }

  @media (max-width: 640px) {
    font-size: ${fontSize(14)};
  }

  @media (max-width: 479px) {
    flex: 1 1 auto;
    display: inline-block;
    width: auto;
    padding: 0;
    padding-left: 0.786em;
  }

  @media (max-width: 414px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    font-size: ${fontSize(14)};
  }
`;

type BlockProps = {
  children: React.Node,
  amount: number
};

function StatsBlock({ children, amount = 0 }: BlockProps) {
  return (
    <Block>
      <Header>{children}:</Header>{" "}
      <Item>
        <Money>{amount}</Money>
      </Item>
    </Block>
  );
}

type Props = {
  profile: Profile,
  accounts: Array<Account>,
  children?: React.Node
};

function Statistics({ profile, accounts, children }: Props) {
  const { active_account_id } = profile;
  const currentAccount = accounts.find(({ id }) => id === active_account_id);
  let type = "demo";

  if (currentAccount !== undefined && currentAccount !== null) {
    type = currentAccount.type;
  }

  const deposit = type === "demo" ? "refill_sum" : "deposit";

  if (profile) {
    return (
      <Stats>
        <StatsBlock amount={profile.finance[deposit]}>
          <Gettext>Investments</Gettext>
        </StatsBlock>
        <StatsBlock amount={profile.finance.withdraw}>
          <Gettext>Withdrawal</Gettext>
        </StatsBlock>
        <StatsBlock amount={profile.balance[type]}>
          <Gettext>Balance</Gettext>
        </StatsBlock>
        {children}
      </Stats>
    );
  }

  return null;
}

export default withData(["profile", "accounts"])(Statistics);



// WEBPACK FOOTER //
// ./src/components/HistoryPages/Statistics.js